import styled from '@emotion/styled';
import {
  ButtonNormalPrimaryMediumIcon,
  ButtonWrapper,
  token,
  WhatsappOutlineMediumIcon,
} from '@ferreri/prever-component-lib';
import { ComponentType, ReactNode } from 'react';

const handleWhatsApp = () => {
  return window.open(
    'https://wa.me/+558000066688?text=Ol%C3%A1%2C%20eu%20gostaria%20de%20informa%C3%A7%C3%B5es%20sobre%20o%20Plano%20Prever',
    '_blank',
    'noopener noreferrer',
  );
};

export const ActionsSection = () => {
  return (
    <Container>
      <WhatsAppButton buttonComponent={ButtonNormalPrimaryMediumIcon} />
    </Container>
  );
};

type WhatsAppButtonProps = {
  buttonComponent: ComponentType<{ icon: ReactNode; children: ReactNode }>;
};

export const WhatsAppButton = (props: WhatsAppButtonProps) => {
  return (
    <ButtonWrapper onClick={handleWhatsApp}>
      <props.buttonComponent icon={<WhatsappOutlineMediumIcon />}>
        Conversar com o atendimento
      </props.buttonComponent>
    </ButtonWrapper>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${token.spacing.spacingSmall};
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  padding: ${token.spacing.spacingMedium};
  border-top: 1px solid ${token.colors.neutralLight};
  background-color: ${token.colors.backgroundMain};
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
`;
